import {
  ADDBOOK,
  DELETEBOOK,
  EDITBOOK,
  LOADED,
  SET_UPDATE_BOOK_ID,
} from "./actionTypes";
import { initialState } from "./initialState";

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDBOOK:
      return {
        ...state,
        books: [...state.books, action.payload],
      };
    case EDITBOOK:
      const updatedBooks = state.books.map((book) => {
        if (book.id === action.payload.id) {
          return {
            ...book,
            ...action.payload.book,
          };
        } else {
          return book;
        }
      });

      return {
        ...state,
        books: updatedBooks,
      };

    case SET_UPDATE_BOOK_ID:
      return {
        ...state,
        isUpdate: action.payload.value,
        currentUpdateid: action.payload.id,
      };
    case DELETEBOOK:
      return state.books.filter((book) => book.id !== action.payload);
    case LOADED:
      return {
        ...state,
        books: action.payload,
      };
    default:
      return state;
  }
};
